import React, { useEffect, useState } from "react";
import "../styles/QuizScoreStyle.css";
import QuizImg from "../../../../assets/images/popQuiz/popQuizImg.png";
import nextVideo from "../../../../assets/images/popQuiz/nextVideo.svg";
import replay from "../../../../assets/images/popQuiz/popQuizReplay.svg";
import GaugeMeter from "./ScoreMeter";
import { Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setNextVideo,
  setNoOfCorrectQn,
  setNoOfQuestions,
  setReplay,
} from "../data/redux/popQuizRedux";
import { RootState } from "../../../../store/store";
import {
  QuizResponse,
  QuestionResponse,
} from "../data/response/popQuizScoreResponse";
import { useApi } from "../../../../service/ApiContext";
import QuizPopUpLogout from "../../../../components/QuizPopUpLogout";
import {
  setQuizComponentActive,
  setQuizOverlayActive,
} from "../data/redux/QuizLogoutRedux";
import logoutUser from "../../../../features/sideBar/data/api_services/LogoutApi";
import { useNavigate } from "react-router-dom";
import Logger from "../../../../utils/Logger";
import { useCamera } from "../../../assessment/components/CameraContext";

const quizData = [
  {
    question:
      " Which part of a robot acts like its 'brainWhich part of a robot acts like its 'brainWhich part of a robot acts like its 'brainWhich part of a robot acts like its 'brainWhich part of a robot acts like its 'brain'?",
    yourAnswer:
      "Which part of a robot acts like its 'brainWhich part of a robot acts like its 'brainWhich part of a robot acts like its 'brainWhich part of a robot acts like its 'brainWhich",
    correctAnswer:
      "Which part of a robot acts like its 'brainWhich part of a robot acts like its 'brainWhich part of a robot acts like its 'brainWhich part of a robot acts like its 'brainWhich",
    explanation: "brain",
    isWrong: true,
  },
  {
    question: "What powers a robot?",
    yourAnswer: "Battery",
    correctAnswer: "Battery",
    explanation: "Batteries provide the energy robots need to function.",
    isWrong: false,
  },
  {
    question: "What part helps a robot move?",
    yourAnswer: "Motor",
    correctAnswer: "Motor",
    explanation: "Motors convert energy into motion.",
    isWrong: false,
  },
  {
    question: "Which sensor helps robots see?",
    yourAnswer: "Ultrasonic Sensor",
    correctAnswer: "Camera",
    explanation: "Cameras allow robots to visually perceive the environment.",
    isWrong: true,
  },
  {
    question: "What allows a robot to make decisions?",
    yourAnswer: "Remote",
    correctAnswer: "Micro",
    explanation: "Microcontrollers are programmed to make decisions.",
    isWrong: true,
  },
];

interface QuizScoreComponentProps {
  response: any; // Replace `any` with actual type if available
}

const QuizScoreComponent: React.FC<QuizScoreComponentProps> = ({
  response,
}) => {
  const dispatch = useDispatch();
  const api = useApi();
  const navigate = useNavigate();
  // State for quiz data
  const [quizData, setQuizData] = useState<QuestionResponse[]>([]);
  const [score, setScore] = useState<number>(0);
  const [totalQuestions, setTotalQuestions] = useState<number>(0);
  const [correctlyAnswered, setCorrectlyAnswered] = useState<number>(0);
  dispatch(setNoOfQuestions(totalQuestions));
  dispatch(setNoOfCorrectQn(correctlyAnswered));
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const quizComponentActive = useSelector(
    (state: RootState) => state.QuizLogout.quizComponentActive,
  );
  const { stopCamera, isCameraEnabled } = useCamera();

  const closeAssessmentCamera = () => {
    stopCamera();
    window.location.reload();
  };
  useEffect(() => {
    if (response) {
      setQuizData(response.questions);
      setScore(response.score);
      setTotalQuestions(response.total_questions);
      setCorrectlyAnswered(response.correctly_answered);
    }
  }, [response]); // Watch for prop changes
  //   useEffect(() => {
  //     // ✅ Mock API Response Example
  //     const quizResponse: QuizResponse = {
  //       total_questions: 3,
  //       correctly_answered: 2,
  //       score: 66,
  //       questions: [
  //         {
  //           question_id: "6adcb39a-5f3b-4c62-9d61-fbc5dbef8601",
  //           question: "question 4 here",
  //           explanation: "Option 3 is Correct",
  //           candidate_answer: {
  //             option_id: "30dbd7f7-866d-4db0-8144-fd096bac43f7",
  //             option: "correct option 3 here",
  //           },
  //           correct_answer: {
  //             option_id: "30dbd7f7-866d-4db0-8144-fd096bac43f7",
  //             option: "correct option 3 here",
  //           },
  //           is_correct: true,
  //         },
  //         {
  //           question_id: "41d07d8d-42ab-40a8-b463-09bf8d9f56cc",
  //           question: "question 3 here",
  //           explanation: "Option 3 is Correct",
  //           candidate_answer: {
  //             option_id: "c64635ed-902c-41f2-a0f4-c7034dbda665",
  //             option: "correct option 3 here",
  //           },
  //           correct_answer: {
  //             option_id: "c64635ed-902c-41f2-a0f4-c7034dbda665",
  //             option: "correct option 3 here",
  //           },
  //           is_correct: true,
  //         },
  //         {
  //           question_id: "67f46758-e3a9-4796-93d8-699d7bdd7592",
  //           question: "question 2 here",
  //           explanation: "Option 3 is Correct",
  //           candidate_answer: {
  //             option_id: "8bc0d8f7-a315-469a-b365-6658339abc61",
  //             option: "option 2 here",
  //           },
  //           correct_answer: {
  //             option_id: "a7a82e6b-9cac-4c45-846b-f9cef8021f1f",
  //             option: "correct option 3 here",
  //           },
  //           is_correct: false,
  //         },
  //       ],
  //     };

  //     // Set states
  //     setQuizData(quizResponse.questions);
  //     setScore(quizResponse.score);
  //     setTotalQuestions(quizResponse.total_questions);
  //     setCorrectlyAnswered(quizResponse.correctly_answered);
  //   }, []);
  const showNextVideo = useSelector(
    (state: RootState) => state.quizReducer.showNextVideo,
  );
  return (
    <div className="score-popquiz-container">
      {quizComponentActive && (
        <QuizPopUpLogout
          title={"Logout"}
          body={"Are you sure you want to logout?"}
          btn1onPressed={() => {
            Logger.info("ok clicked");
            if (document.fullscreenElement) {
              document.exitFullscreen();
            }
            dispatch(setQuizComponentActive(false));
            dispatch(setQuizOverlayActive(false));
            logoutUser(
              dispatch,
              navigate,
              userData.candidate_id || "",
              api,
              closeAssessmentCamera,
            );
          }}
          btn2onPressed={() => {
            dispatch(setQuizComponentActive(false));
            // setShowQuizComponent(true);
          }}
        ></QuizPopUpLogout>
      )}
      <div
        className="score-popquiz-header"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <img src={QuizImg} alt="quiz" className="score-popQuizImg" />
        <div
          style={{
            justifyContent: "space-between",
            display: "flex",
            gap: "20px",
          }}
        >
          <button
            className="score-skip-popquiz"
            onClick={() => {
              dispatch(setReplay(true));
            }}
          >
            <img
              src={replay}
              alt="replay"
              style={{ height: "15px", width: "20px", marginBottom: "2px" }}
            />
            Replay
          </button>
          {showNextVideo && (
            <button
              className="score-skip-popquiz"
              onClick={() => {
                dispatch(setNextVideo(true));
              }}
            >
              <img
                src={nextVideo}
                alt="next"
                style={{ height: "15px", width: "20px", marginBottom: "2px" }}
              />
              Next
            </button>
          )}
        </div>
      </div>

      <div className="score-scrollContainer">
        {/* Left static result panel */}
        <div className="score-leftPanel" style={{ paddingLeft: "30px" }}>
          <div>
            <div style={{ fontSize: "22px", fontFamily: "Mazzard" }}>
              Quiz Result
            </div>
            <br></br>
            <br></br>

            <div style={{ fontFamily: "Mazzard" }}>You Scored</div>
            <GaugeMeter value={score} />
            <h3 style={{ fontFamily: "Mazzard", fontSize: "36px" }}>
              {score}%
            </h3>
            <div style={{ fontFamily: "Mazzard" }}>
              {" "}
              {correctlyAnswered}/{totalQuestions} Correct Answers
            </div>
          </div>
        </div>

        {/* Right panel with question cards */}
        <div className="score-rightPanel">
          {/* <div className="rightSide-score"> */}
          {quizData.map((item, index) => (
            <div
              className="score-questionCard"
              key={item.question_id}
              style={{
                backgroundColor: item.is_correct ? "#C9FFE8" : "#FFE0DF",
              }}
            >
              {/* Question */}
              <div
                style={{
                  fontFamily: "Mazzard",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div> {index + 1}.</div>
                  <div>{item.question}</div>
                </div>
              </div>

              {/* Answers */}
              <div className="score-answers-container">
                {/* Your Answer Section */}
                <div className="score-answer-group">
                  <strong className="score-answer-label">Your Answer:</strong>
                  <div className="score-answer-option">
                    <div className="score-option-circle">
                      {item.candidate_answer.option_label}
                    </div>
                    <div className="score-wrong">
                      {item.candidate_answer.option}
                    </div>
                  </div>
                </div>

                {/* Correct Answer Section */}
                <div className="score-answer-group">
                  <strong className="score-answer-label">
                    Correct Answer:
                  </strong>
                  <div className="score-answer-option">
                    <div className="score-option-circle correct">
                      {item.correct_answer.option_label}
                    </div>
                    <div className="score-correct">
                      {item.correct_answer.option}
                    </div>
                  </div>
                </div>
              </div>

              {/* Explanation */}
              <p>
                <strong>Explanation:</strong>
                <div>{item.explanation}</div>
              </p>
            </div>
          ))}
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};
export default QuizScoreComponent;
